__webpack_require__.p = "https://translate.smartauto.com.tw/";